import { usePath } from "@fdoh/health-ui-react";
import { useHistory } from "react-router-dom";
import { ApplicationInspectionRequest, SearchResultsProps } from "./SearchResults.types";
import useClient from "../../hooks/useInspectionClient";
import { toast } from "react-toastify";
import { useAppConfig } from "@fdoh/health-ui-react";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
import { createContext, useContext } from "react";

export const SearchResultsPage = (props: SearchResultsProps) => {

    const history = useHistory();
    const path = usePath();
    const client = useClient();
    const applicationData = props.appData;
    const applicationNumber = props.apNumber;
    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const userStatus = useProfile(application) as UserSecurityInput;

    const goToInspectionHome = () => {
        history.push(`/inspectionDetails/` + applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1)[0].applicationInspectionId);
    }

    const createNew = async () => {
        const createInspectionData: ApplicationInspectionRequest = {
            applicationId: applicationData?.applicationId,
            inspectionStatusId: 1,
            isApproved: false,
            providerId: 0,
            dateCreated: new Date(),
            createdBy: userStatus.userName,
            dateUpdated: new Date(),
            updatedBy: userStatus.userName,
            userId: userStatus.userSecurityId,
        };
        try {
            let endpoint = 'ApplicationInspection/';
            const inspectionResponse = await client.api(endpoint).post(createInspectionData);
            history.push(`/inspectionDetails/${inspectionResponse.data?.id}`);
        } catch (error: any) {
            toast.error(error);
        }
    }

    return applicationData ? (
        <div>
            {applicationData && !applicationData?.isAprecordsDisable && (applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1).length > 0) && (
                <>
                    <div className="card-body">
                        <div className="row g-2 align-items-center">
                            <div className="col-auto">
                                <div className="bg-welcome msg">Search results</div>
                            </div>
                            <div className="col-auto text-muted">
                                Showing results for '{applicationData.apnumber}'
                            </div>
                        </div>
                    </div>
                    <button className="card card-link w-100" onClick={goToInspectionHome} title="Open Inspection">
                        <div className="card-body w-100">
                            <div className="row">
                                <div className="col-auto">
                                    <div className="datagrid-item">
                                        <div className="datagrid-title">AP#</div>
                                        <div className="datagrid-content">{applicationData.apnumber}</div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="datagrid-item">
                                        <div className="datagrid-title">Permit Date</div>
                                        <div className="datagrid-content">{new Date(applicationData.permitDate).toLocaleDateString()}</div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="datagrid-item">
                                        <div className="datagrid-title">PROPERTY ADDRESS</div>
                                        <div className="datagrid-content">{applicationData.propertyStreetAddress + ", " + applicationData.propertyCity + ", " + applicationData.propertyState + ", " + applicationData.propertyZipCode}</div>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <span className="avatar rounded"><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M9 6l6 6l-6 6"></path>
                                    </svg></span>
                                </div>
                            </div>
                        </div>
                    </button>
                </>
            )}
            {applicationData && !applicationData?.isAprecordsDisable &&
                (applicationData?.applicationInspections?.length === 0 || applicationData?.applicationInspections?.filter(x => x.inspectionStatusId === 1).length === 0)
                && (

                    <div className="align-items-center">
                        <div>
                            {/* <div className="bg-welcome msg">No results found for '{applicationNumber}'</div>*/}
                            <>

                                <div className="card-body w-100">
                                    <div className="row">
                                        <div className="col-auto">
                                            <div className="datagrid-item">
                                                <div className="datagrid-title">AP#</div>
                                                <div className="datagrid-content">{applicationData.apnumber}</div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="datagrid-item">
                                                <div className="datagrid-title">Permit Date</div>
                                                <div className="datagrid-content">{new Date(applicationData.permitDate).toLocaleDateString()}</div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="datagrid-item">
                                                <div className="datagrid-title">PROPERTY ADDRESS</div>
                                                <div className="datagrid-content">{applicationData.propertyStreetAddress + ", " + applicationData.propertyCity + ", " + applicationData.propertyState + ", " + applicationData.propertyZipCode}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            <div><button className="btn btn-primary" onClick={createNew}>Create New Inspection</button></div>
                        </div>
                    </div>

                )}
            {applicationData?.isAprecordsDisable ? <p className="bg-error-msg">
                County tied to this '{props.apNumber}' is restricted!
            </p> : (parseInt(applicationData?.applicationId) == 0) && (
                <p className="bg-welcome msg">
                    No Results found for '{props.apNumber}'
                </p>
            )}
        </div>
    ) : <div>
    </div>
};



export default SearchResultsPage;


